// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";

import ModuleBase from "#/common/ModuleBase";

import { Headline } from "#/components/headline/Headline";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    Headline,
  },
})
export class AnchorModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return instance["background"];
  }

  get getHeadlineSize() {
    switch (this.instance["headline"]["type"]) {
      case "h1":
        return 1;
      case "h2":
        return 2;
      case "h3":
        return 3;
      case "subline":
        return 4;
      default:
        return 1;
    }
  }

  get headlineTheme() {
    let color = this.instance["background"];
    return color == "black" ? "secondary" : "default";
  }
}
